/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Concierge_AgentInputs */

const en_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Concierge Agent`)
};

const es_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agente Conserje IA`)
};

const fr_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent Concierge IA`)
};

const de_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Concierge-Agent`)
};

const ja_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIコンシェルジュエージェント`)
};

const zh_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 礼宾客服代理`)
};

const ar_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وكيل المساعد الذكي`)
};

const id_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen Pramutamu AI`)
};

const it_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agente Concierge IA`)
};

const ru_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ИИ-агент (Консьерж)`)
};

const pt_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agente Concierge IA`)
};

const ko_ai_concierge_agent = /** @type {(inputs: Ai_Concierge_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 컨시어지 에이전트`)
};

/**
* | output |
* | --- |
* | "AI Concierge Agent" |
*
* @param {Ai_Concierge_AgentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_concierge_agent = /** @type {((inputs?: Ai_Concierge_AgentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Concierge_AgentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_concierge_agent(inputs)
	if (locale === "es") return es_ai_concierge_agent(inputs)
	if (locale === "fr") return fr_ai_concierge_agent(inputs)
	if (locale === "de") return de_ai_concierge_agent(inputs)
	if (locale === "ja") return ja_ai_concierge_agent(inputs)
	if (locale === "zh") return zh_ai_concierge_agent(inputs)
	if (locale === "ar") return ar_ai_concierge_agent(inputs)
	if (locale === "id") return id_ai_concierge_agent(inputs)
	if (locale === "it") return it_ai_concierge_agent(inputs)
	if (locale === "ru") return ru_ai_concierge_agent(inputs)
	if (locale === "pt") return pt_ai_concierge_agent(inputs)
	return ko_ai_concierge_agent(inputs)
});